module.exports = __webpack_public_path__ + "static/media/hingeInstallGuide.da68d34d.png";